import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

interface HeroProps {
  heading: string;
  subheading?: string;
  backgroundImage?: string;
  ctaText?: string;
  ctaLink?: string;
  overlay?: boolean;
  compact?: boolean;
}

const Hero: React.FC<HeroProps> = ({
  heading,
  subheading,
  backgroundImage,
  ctaText,
  ctaLink,
  overlay = true,
  compact = false,
}) => {
  return (
    <section
      className={`hero ${compact ? 'hero-compact' : ''}`}
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
      }}
    >
      {overlay && <div className="hero-overlay" />}
      <div className="hero-content container">
        <h1 className="hero-heading">{heading}</h1>
        {subheading && <p className="hero-subheading">{subheading}</p>}
        {ctaText && ctaLink && (
          <Link to={ctaLink} className="btn btn-primary hero-cta">
            {ctaText}
          </Link>
        )}
      </div>
    </section>
  );
};

export default Hero;
